import nprogress from 'nprogress';

// Configure NProgress
nprogress.configure({
  showSpinner: false,
  trickle: true,
  trickleSpeed: 200,
  minimum: 0.08,
  easing: 'ease',
  speed: 200,
});

/**
 * Static ProgressBar utility class
 * Uses the same NProgress configuration as shadcn/ui Loading component
 */
export default class ProgressBar {
  static start() {
    nprogress.start();
  }

  static done() {
    nprogress.done();
  }
}
